/* Yooppee wishlist panel + toast (needs assets/wishlist.js).
   Slide-out panel (snippets/wishlist-drawer.liquid) opened from the header heart
   or the toast's View button. Rows are filled from
   /products/{handle}?view=wishlist-data (templates/product.wishlist-data.liquid):
   alias title, tags, price, saved date, remove heart and a quick add:
   A2 cart for single-variant products, '+' with the "Choose an option" bubble
   for multi-variant ones, a SOLD OUT pill when nothing is available.
   Picked options live until the page is left. */
(function () {
  'use strict';
  var W = window.YPWishlist;
  var drawer = document.getElementById('Wishlist-Drawer');
  if (!W || !drawer || drawer._wlReady) {
    return;
  }
  drawer._wlReady = true;

  var overlay = document.querySelector('[data-wl-overlay]');
  var listEl = drawer.querySelector('[data-wl-list]');
  var emptyEl = drawer.querySelector('[data-wl-empty]');
  var loadingEl = drawer.querySelector('[data-wl-loading]');
  var footerEl = drawer.querySelector('[data-wl-footer]');
  var subEl = drawer.querySelector('[data-wl-sub]');
  var countEl = drawer.querySelector('[data-wl-title-count]');
  var bodyEl = drawer.querySelector('.wl-body');
  var heartTpl = drawer.querySelector('template[data-wl-heart]');

  function tt(key, fallback) {
    return drawer.getAttribute('data-t-' + key) || fallback;
  }
  var T = {
    saved: tt('saved', 'Saved [date]'),
    soldOut: tt('sold-out', 'Sold out'),
    addToCart: tt('add-to-cart', 'Add to cart'),
    chooseOptions: tt('choose-options', 'Choose options'),
    chooseOption: tt('choose-option', 'Choose an option'),
    change: tt('change', 'Change'),
    error: tt('error', 'Could not add to cart. Please try again.'),
    added: tt('added', 'Added to wishlist'),
    view: tt('view', 'View'),
    remove: tt('remove', 'Remove from wishlist'),
    synced: tt('synced-to-account', 'Your wishlist is saved to your account')
  };
  var icons = {
    cart: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2.3 3.3L4.3 3.8Q5.1 4 5.3 4.8L5.9 7.2"/><path d="M5.7 7.4Q5.5 6.2 6.8 6.2H19.6Q21.2 6.2 20.9 7.8L20 13.3Q19.6 15.9 17 15.9H9.4Q7.3 15.9 6.9 13.8Z"/><path d="M7.3 15.4Q7.8 18 10 18H18.3"/><circle cx="9.9" cy="20.6" r="1.5"/><circle cx="17.3" cy="20.6" r="1.5"/><circle cx="11.1" cy="10.2" r="1.35" fill="currentColor" stroke="none"/><circle cx="16" cy="10.2" r="1.35" fill="currentColor" stroke="none"/><path d="M11.4 12.6q2.15 1.9 4.3 0"/></svg>',
    plus: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"><path d="M12 6.6v10.8M6.6 12h10.8"/></svg>',
    check: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.2L19 7"/></svg>'
  };
  var heartHtml = heartTpl ? heartTpl.innerHTML : '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var LOGIN_FLAG_KEY = 'yp_wl_login_v1';
  var LOGIN_FLAG_TTL = 30 * 60 * 1000;
  function isLoggedIn() {
    return document.body.classList.contains('customer-logged-in') || drawer.getAttribute('data-logged-in') === 'true';
  }
  function safePath() {
    try {
      var p = window.location.pathname + window.location.search;
      var blocked = ['/account', '/customer_authentication', '/challenge', '/password', '/checkouts'];
      if (!p || p.charAt(0) !== '/' || p.slice(0, 2) === '//' || p.slice(0, 2) === '/\\' || p.indexOf('\\') !== -1 || /[\u0000-\u001f\u007f]/.test(p) || p.length > 512) {
        return '/';
      }
      for (var i = 0; i < blocked.length; i++) {
        if (window.location.pathname.indexOf(blocked[i]) === 0) {
          return '/';
        }
      }
      return p;
    } catch (e) {
      return '/';
    }
  }
  function loginHref(create) {
    var href = '/customer_authentication/login?return_to=' + encodeURIComponent(safePath());
    return create ? href + '&ui_hint=create' : href;
  }
  function updateLoginHrefs() {
    var loginLinks = drawer.querySelectorAll('[data-wl-login]');
    var createLinks = drawer.querySelectorAll('[data-wl-create-account]');
    for (var i = 0; i < loginLinks.length; i++) {
      loginLinks[i].setAttribute('href', loginHref(false));
    }
    for (var j = 0; j < createLinks.length; j++) {
      createLinks[j].setAttribute('href', loginHref(true));
    }
  }
  function rememberLogin(link) {
    var sourceEl = link.closest('[data-wl-login-source]');
    var from = sourceEl && sourceEl.getAttribute('data-wl-login-source') === 'empty' ? 'empty' : 'panel';
    try {
      window.sessionStorage.setItem(LOGIN_FLAG_KEY, JSON.stringify({
        v: 1,
        ts: Date.now(),
        from: from,
        path: safePath()
      }));
    } catch (e) {
      /* storage can be blocked; login still proceeds normally */
    }
  }
  function centsPrice(value) {
    if (value === null || value === undefined || String(value).trim() === '') {
      return null;
    }
    var cents = Number(value);
    return isFinite(cents) && cents >= 0 ? (cents / 100).toFixed(2) : null;
  }
  function activeCurrency() {
    try {
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      return typeof cur === 'string' && /^[A-Z]{3}$/.test(cur) ? cur : null;
    } catch (e) {
      return null;
    }
  }
  function cleanVariantTitle(value) {
    if (typeof value !== 'string') {
      return null;
    }
    var title = value.trim();
    return !title || title.toLowerCase() === 'default title' ? null : title;
  }
  function wishlistMeta(li, variantId) {
    var d = li._d || {};
    var it = li._it || {};
    var variants = d.variants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) {
        variant = variants[i];
        break;
      }
    }
    if (!variant && picked[it.handle] != null) {
      variant = variants[picked[it.handle]] || null;
    }
    var sameStoredVariant = String(it.variantId || '') === String(variantId || '');
    var hasVariants = d.has_variants === true || variants.length > 1;
    var price = variant && variant.price_cents !== null && variant.price_cents !== undefined ? centsPrice(variant.price_cents) : null;
    if (!price && sameStoredVariant) {
      price = typeof it.price === 'string' ? it.price : null;
    }
    return {
      productTitle: d.product_title || it.productTitle || d.title || null,
      variantTitle: hasVariants && variant ? cleanVariantTitle(variant.title) : (sameStoredVariant ? cleanVariantTitle(it.variantTitle) : null),
      price: price,
      currency: it.currency || activeCurrency()
    };
  }

  /* ---- product data (one request per handle per page view) ---- */
  var cache = {};
  function fetchItem(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=wishlist-data', {
        credentials: 'same-origin' /* no JSON Accept header: Shopify would answer with the stock product JSON instead of this view */
      }).then(function (r) {
        if (r.status === 404) {
          return { missing: true };
        }
        if (!r.ok) {
          throw new Error('HTTP ' + r.status);
        }
        return r.text().then(function (s) {
          return JSON.parse(s);
        });
      }).catch(function () {
        delete cache[handle];
        return null;
      });
    }
    return cache[handle];
  }

  function savedText(ts) {
    if (!ts) {
      return '';
    }
    var d = new Date(ts);
    var opts = { month: 'short', day: 'numeric' };
    if (d.getFullYear() !== new Date().getFullYear()) {
      opts.year = 'numeric';
    }
    var s;
    try {
      s = d.toLocaleDateString(document.documentElement.lang || undefined, opts);
    } catch (e) {
      s = d.toDateString();
    }
    return T.saved.replace('[date]', s);
  }

  /* ---- rows ---- */
  var picked = {}; /* handle -> variant index, kept while on this page */
  function rowHtml(it, d) {
    var vs = (d && d.variants) || [];
    var available = !!(d && d.available);
    var multi = vs.length > 1;
    var sel = multi && picked[it.handle] != null ? vs[picked[it.handle]] : null;
    var url = d && d.url ? d.url : root + 'products/' + encodeURIComponent(it.handle);
    var title = d && d.title ? d.title : it.handle;
    var html = '<a class="wl-item-img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">'
      + (d && d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy" width="96" height="96">' : '')
      + '</a><div class="wl-item-info"><a class="wl-item-title" href="' + esc(url) + '">' + esc(title) + '</a>';
    if (d && d.tags && d.tags.length) {
      html += '<div class="wl-item-tags">' + d.tags.map(function (tag, i) {
        return '<span class="wl-tag' + (i === 0 ? ' wl-tag--first' : '') + '">' + esc(tag) + '</span>';
      }).join('') + '</div>';
    }
    html += '<p class="wl-item-meta">' + esc(savedText(it.addedAt)) + '</p>';
    if (sel) {
      html += '<p class="wl-item-sel">' + icons.check + '<span>' + esc(sel.title) + '</span><span aria-hidden="true">·</span><button type="button" class="wl-sel-change">' + esc(T.change) + '</button></p>';
    }
    var price = sel ? sel.price : (d ? d.price : '');
    html += '<div class="wl-item-row"><span class="wl-item-price' + (sel ? ' is-pick' : '') + '">' + (price || '') + '</span>';
    if (!d) {
      html += '';
    } else if (!available) {
      html += '<span class="wl-so">' + esc(T.soldOut) + '</span>';
    } else if (multi && !sel) {
      html += '<button type="button" class="wl-atc wl-atc--pick" aria-label="' + esc(T.chooseOptions) + '" aria-haspopup="listbox" aria-expanded="false">' + icons.plus + '</button>';
    } else {
      var v = sel || vs[0];
      html += '<button type="button" class="wl-atc" data-variant-id="' + (v ? v.id : '') + '" aria-label="' + esc(T.addToCart) + '">' + icons.cart + '</button>';
    }
    html += '</div><p class="wl-item-err" role="alert" hidden></p></div>'
      + '<button type="button" class="wl-heart wl-heart--row is-on" data-wishlist-toggle data-wishlist-source="panel" data-handle="' + esc(it.handle) + '" data-product-id="' + esc(it.id || (d && d.id) || '') + '" aria-pressed="true" aria-label="' + esc(T.remove) + '">' + heartHtml + '</button>';
    return html;
  }
  function makeRow(it, d) {
    var li = document.createElement('li');
    li.className = 'wl-item' + (d && !d.available ? ' is-so' : '');
    li.setAttribute('data-handle', it.handle);
    li._it = it;
    li._d = d;
    li.innerHTML = rowHtml(it, d);
    return li;
  }
  function refreshRow(li) {
    var fresh = makeRow(li._it, li._d);
    li.parentNode.replaceChild(fresh, li);
    return fresh;
  }

  var token = 0;
  function render() {
    updateLoginHrefs();
    var its = W.list();
    countEl.textContent = its.length ? '(' + its.length + ')' : '';
    closePicker(false);
    if (!its.length) {
      listEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      subEl.hidden = true;
      loadingEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;
    subEl.hidden = false;
    var mine = ++token;
    if (!listEl.children.length) {
      loadingEl.hidden = false;
    }
    Promise.all(its.map(function (it) {
      return fetchItem(it.handle).then(function (d) {
        return { it: it, d: d };
      });
    })).then(function (rows) {
      if (mine !== token) {
        return;
      }
      loadingEl.hidden = true;
      var frag = document.createDocumentFragment();
      var gone = [];
      rows.forEach(function (r) {
        if (r.d && r.d.missing) {
          gone.push(r.it.handle);
          return;
        }
        frag.appendChild(makeRow(r.it, r.d));
      });
      var hadFocus = isOpen && drawer.contains(document.activeElement);
      listEl.innerHTML = '';
      listEl.appendChild(frag);
      if (hadFocus && !drawer.contains(document.activeElement)) {
        drawer.focus({ preventScroll: true }); /* the focused row (e.g. its heart) was re-rendered: keep Esc / Tab inside the panel */
      }
      gone.forEach(function (h) {
        W.remove(h, 'prune', true); /* product deleted or unpublished */
      });
    });
  }

  /* ---- option bubble ---- */
  var pop = null;
  function closePicker(returnFocus) {
    if (!pop) {
      return;
    }
    var li = pop._li;
    pop.parentNode && pop.parentNode.removeChild(pop);
    pop = null;
    var trig = li && li.querySelector('.wl-atc--pick');
    if (trig) {
      trig.setAttribute('aria-expanded', 'false');
      trig.classList.remove('is-open');
      if (returnFocus) {
        trig.focus();
      }
    }
  }
  function openPicker(li) {
    closePicker(false);
    var d = li._d;
    if (!d || !d.variants) {
      return;
    }
    var cur = picked[li._it.handle];
    var box = document.createElement('div');
    box.className = 'wl-pop-list';
    box.setAttribute('role', 'listbox');
    box.setAttribute('aria-label', T.chooseOption);
    var html = '<p class="wl-pop-h" aria-hidden="true">' + esc(T.chooseOption) + '</p>';
    d.variants.forEach(function (v, i) {
      var on = cur === i;
      html += '<button type="button" class="wl-opt' + (v.available ? '' : ' is-so') + '" role="option" data-i="' + i + '" aria-selected="' + (on ? 'true' : 'false') + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + '>'
        + '<span class="wl-opt-ck">' + (on ? icons.check : '') + '</span><span class="wl-opt-t">' + esc(v.title) + '</span><span class="wl-opt-p">' + (v.available ? v.price : esc(T.soldOut)) + '</span></button>';
    });
    box.innerHTML = html;
    box._li = li;
    var row = li.querySelector('.wl-item-row');
    row.appendChild(box);
    pop = box;
    var trig = li.querySelector('.wl-atc--pick');
    if (trig) {
      trig.setAttribute('aria-expanded', 'true');
      trig.classList.add('is-open');
    }
    /* open downwards; flip up when the list would clip it */
    var lb = bodyEl.getBoundingClientRect();
    var bb = box.getBoundingClientRect();
    if (bb.bottom > lb.bottom - 8 && bb.top - bb.height - row.offsetHeight > lb.top) {
      box.classList.add('is-up');
    }
    var first = box.querySelector('.wl-opt[aria-selected="true"]') || box.querySelector('.wl-opt:not([disabled])');
    if (first) {
      first.focus({ preventScroll: true });
    }
    if (box.getBoundingClientRect().bottom > lb.bottom) {
      box.scrollIntoView({ block: 'nearest' });
    }
  }
  function pick(li, i) {
    var v = li._d && li._d.variants[i];
    if (!v || !v.available) {
      return;
    }
    picked[li._it.handle] = i;
    closePicker(false);
    var fresh = refreshRow(li);
    var cartBtn = fresh.querySelector('.wl-atc');
    if (cartBtn) {
      cartBtn.focus();
    }
  }

  /* ---- add to cart (Ajax API, then the theme's cart drawer) ---- */
  function addToCart(btn, li) {
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid || btn.disabled) {
      return;
    }
    var err = li.querySelector('.wl-item-err');
    err.hidden = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, j: j };
      });
    }).then(function (res) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (!res.ok || (res.j && res.j.status)) {
        err.textContent = (res.j && (res.j.description || res.j.message)) || T.error;
        err.hidden = false;
        return;
      }
      var meta = wishlistMeta(li, vid);
      W.publish('wishlist_add_to_cart', {
        id: li._d && li._d.id,
        handle: li._it.handle,
        variantId: vid,
        productTitle: meta.productTitle,
        variantTitle: meta.variantTitle,
        price: meta.price,
        currency: meta.currency
      }, 'panel');
      close(false);
      var cart = document.getElementById('Cart-Drawer');
      if (cart && typeof cart.open === 'function') {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        cart.open();
      } else {
        window.location.href = root + 'cart';
        return;
      }
      if (typeof window.dispatchCustomEvent === 'function') {
        var item = res.j && res.j.items ? res.j.items[0] : res.j;
        window.dispatchCustomEvent('cart:item-added', { product: item });
      }
    }).catch(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      err.textContent = T.error;
      err.hidden = false;
    });
  }

  drawer.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target : null;
    if (!target || target.closest('[data-wishlist-toggle]')) {
      return;
    }
    var loginLink = target.closest('[data-wl-login], [data-wl-create-account]');
    if (loginLink) {
      updateLoginHrefs();
      rememberLogin(loginLink);
      return;
    }
    if (target.closest('[data-wl-close]')) {
      e.preventDefault();
      close(true);
      return;
    }
    var li = target.closest('.wl-item');
    var opt = target.closest('.wl-opt');
    if (opt) {
      if (!opt.disabled) {
        pick(opt.closest('.wl-item'), +opt.getAttribute('data-i'));
      }
      return;
    }
    if (pop && !target.closest('.wl-pop-list')) {
      var sameTrigger = li && li === pop._li && target.closest('.wl-atc--pick, .wl-sel-change, .wl-item-price.is-pick');
      closePicker(false);
      if (sameTrigger) {
        return;
      }
    }
    if (!li) {
      return;
    }
    if (target.closest('.wl-atc--pick, .wl-sel-change, .wl-item-price.is-pick')) {
      openPicker(li);
      return;
    }
    var atc = target.closest('.wl-atc');
    if (atc) {
      addToCart(atc, li);
    }
  });

  /* ---- open / close ---- */
  var isOpen = false;
  var lastFocus = null;
  function setExpanded(on) {
    var ts = document.querySelectorAll('[data-wishlist-open]');
    for (var i = 0; i < ts.length; i++) {
      ts[i].setAttribute('aria-expanded', on ? 'true' : 'false');
    }
  }
  function open() {
    if (isOpen) {
      return;
    }
    updateLoginHrefs();
    isOpen = true;
    lastFocus = document.activeElement;
    var cart = document.getElementById('Cart-Drawer');
    if (cart && cart.isOpen && typeof cart.close === 'function') {
      cart.close();
    }
    hideToast();
    render();
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
    }
    document.documentElement.classList.add('wl-locked');
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) {
        overlay.classList.add('is-on');
      }
    });
    setExpanded(true);
    window.setTimeout(function () {
      var x = drawer.querySelector('.wl-x');
      if (x && isOpen) {
        x.focus({ preventScroll: true });
      }
    }, 60);
  }
  function close(returnFocus) {
    if (!isOpen) {
      return;
    }
    isOpen = false;
    closePicker(false);
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('is-on');
      overlay.hidden = true;
    }
    document.documentElement.classList.remove('wl-locked');
    setExpanded(false);
    if (returnFocus && lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
  }
  if (overlay) {
    overlay.addEventListener('click', function () {
      close(true);
    });
  }
  document.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target : null;
    var t = target ? target.closest('[data-wishlist-open]') : null;
    if (!t) {
      return;
    }
    e.preventDefault();
    if (isOpen) {
      close(true);
    } else {
      open();
    }
  });
  document.addEventListener('keydown', function (e) {
    /* focus fell outside the open panel (clicked the overlay, element removed): Esc still closes it */
    if (isOpen && e.key === 'Escape' && !drawer.contains(document.activeElement)) {
      e.stopPropagation();
      close(true);
    }
  }, true);
  drawer.addEventListener('keydown', function (e) {
    e.stopPropagation(); /* keep the keycap modal's Esc / Tab / arrow handlers out of the panel */
    if (e.key === 'Escape') {
      if (pop) {
        closePicker(true);
      } else {
        close(true);
      }
      return;
    }
    if (pop && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      var opts = Array.prototype.slice.call(pop.querySelectorAll('.wl-opt:not([disabled])'));
      var i = opts.indexOf(document.activeElement);
      if (opts.length) {
        e.preventDefault();
        i = e.key === 'ArrowDown' ? (i + 1) % opts.length : (i - 1 + opts.length) % opts.length;
        opts[i].focus();
      }
      return;
    }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetParent !== null && !el.closest('[hidden]');
      });
      if (!f.length) {
        return;
      }
      if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        f[0].focus();
      }
    }
  });

  /* ---- toast ---- */
  var toast = null;
  var toastTimer = null;
  function hideToast() {
    if (toast) {
      toast.classList.remove('is-on');
    }
    window.clearTimeout(toastTimer);
  }
  function showToast(message, withView, inDrawer) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wl-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    if (inDrawer) {
      toast.classList.add('wl-toast--in-drawer');
    } else {
      toast.classList.remove('wl-toast--in-drawer');
    }
    var html = '<span class="wl-toast-ic" aria-hidden="true">' + heartHtml + '</span><span class="wl-toast-t">' + esc(message || T.added) + '</span>';
    if (withView !== false) {
      html += '<button type="button" class="wl-toast-v">' + esc(T.view) + '</button>';
    }
    toast.innerHTML = html;
    var viewButton = toast.querySelector('.wl-toast-v');
    if (viewButton) {
      viewButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hideToast();
        open();
      });
    }
    window.clearTimeout(toastTimer);
    toast.classList.remove('is-on');
    void toast.offsetWidth;
    toast.classList.add('is-on');
    toastTimer = window.setTimeout(hideToast, 2800);
  }

  function waitForWishlistSync(done) {
    var finished = false;
    var timer = null;
    function finish(detail) {
      if (finished) {
        return;
      }
      finished = true;
      document.removeEventListener('yp:wishlist:synced', onSynced);
      window.clearTimeout(timer);
      done(detail || { ok: false, action: 'none' });
    }
    function onSynced(e) {
      finish(e.detail);
    }
    if (window.YPWishlistSyncState && window.YPWishlistSyncState.done) {
      finish(window.YPWishlistSyncState);
      return;
    }
    document.addEventListener('yp:wishlist:synced', onSynced);
    timer = window.setTimeout(function () {
      finish({ ok: false, action: 'none' });
    }, 8000);
  }

  function consumeLoginFlag() {
    var raw = null;
    try {
      raw = window.sessionStorage.getItem(LOGIN_FLAG_KEY);
      if (raw === null) {
        return;
      }
      window.sessionStorage.removeItem(LOGIN_FLAG_KEY);
    } catch (e) {
      return;
    }
    var flag = null;
    try {
      flag = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!flag || flag.v !== 1 || typeof flag.ts !== 'number' || !isFinite(flag.ts) || Date.now() - flag.ts > LOGIN_FLAG_TTL || typeof flag.path !== 'string' || (flag.from !== 'panel' && flag.from !== 'empty') || !isLoggedIn()) {
      return;
    }
    waitForWishlistSync(function (detail) {
      open();
      if (detail && detail.ok === true) {
        showToast(T.synced, false, true);
      }
    });
  }

  W.onChange(function (detail) {
    if (detail.type === 'add' && detail.source !== 'panel' && !isOpen) {
      showToast();
    }
    if (isOpen) {
      render(); /* also for phase-2 'replace' (the synced account list) */
    }
  });
  W.open = open;
  W.close = close;
  updateLoginHrefs();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', consumeLoginFlag);
  } else {
    consumeLoginFlag();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      consumeLoginFlag();
    }
  });
})();
